import { Moment } from 'moment';

export class BufferChangeHistory {
    constructor(public readonly id: string, public readonly date: Moment, public readonly parameter: string, public readonly reason: string, public readonly oldValue: number, public readonly newValue: number) {
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/buffer-change-history/buffer-change-history.ts